<template>
  <div id="establishments-navigation">
    <div v-sticky class="navigation-sticky" sticky-z-index="20">
      <div class="navigation-bar">
        <div class="text-right">
          <btn class="navigation-toggle"
               @click="show = !show" type="primary">
            <span class="glyphicon glyphicon-menu-hamburger"
                  aria-hidden="true">
            </span>
          </btn>
        </div>
        <collapse v-if="sid != null" v-model="show">
          <div v-if="error">
          </div>
          <div v-else-if="loaded && surveillance" class="navigation-contents">
            <p class="nav-title text-center">
              <strong>{{ surveillance.establishment.name }}</strong><br />
              <small>SPIADI {{ surveillance.year }}</small>
            </p>
            <hr>
            <dropdown style="width: 100%">
              <div class="action-button" role="button">
                <span class="glyphicon glyphicon-eject" aria-hidden="true">
                </span>
                <span>Changer d'établissement</span>
              </div>
              <template slot="dropdown">
                <router-link v-for="s in otherSurveillances"
                             v-if="s.id !== surveillance.id"
                             tag="li"
                             :key="s.id"
                             :to="`/establishments/${s.year}/${s.id}`">
                  <a role="button">
                    <small>{{ year }}</small> - {{ s.establishment.name }}
                  </a>
                </router-link>
                <li v-if="otherSurveillances.length > 1"><hr></li>
                <router-link to="/establishments" tag="li">
                  <a role="button">
                    Revenir à la liste des surveillances
                  </a>
                </router-link>
              </template>
            </dropdown>
            <checkbox-menu :options="options" style="width: 100%">
              <div class="action-button" role="button">
                <span class="glyphicon glyphicon-cog" aria-hidden="true">
                </span>
                Options
              </div>
            </checkbox-menu>
            <!-- >div class="action-button" role="button"
                 @click.stop="config.sheet.cheatsheet = true">
                 <span class="glyphicon glyphicon-question-sign" aria-hidden="true">
                 </span>
                 Aide
                 </div -->
            <hr>
            <router-link
              tag="div" active-class="active"
              role="button"
              class="no-outline action-button" :to="`${routePrefix}/dashboard`">
              <span class="glyphicon glyphicon-home" aria-hidden="true">
              </span>
              Accueil
            </router-link>
            <router-link tag="div" active-class="active"
                         v-if="isRegistrator && denominatorsAvailable"
                         role="button"
                         class="no-outline action-button"
                         :to="`${routePrefix}/denominators/denominators`">
              <span class="glyphicon glyphicon-list-alt"
                    aria-hidden="true">
              </span>
              Fiche Établissement
            </router-link>
            <router-link tag="div" active-class="active"
                         v-if="isRegistrator && toolsUsageSheetAvailable"
                         role="button"
                         class="no-outline action-button"
                         :to="`${routePrefix}/denominators/toolsUsage`">
              <span class="glyphicon glyphicon-blackboard"
                    aria-hidden="true">
              </span>
              Fiche Formation
            </router-link>
            <div class="submenu-results"
                 v-if="hasGlobalStatistics && year !== '2019'">
              <hr>
              <div :class="{ 'submenu-active': module === 'results' }">
                <router-link tag="div"
                             role="button"
                             class="no-outline action-button"
                             :to="`${moduleRoutePrefix}/results/results`">
                  <span class="glyphicon glyphicon-plus"
                        v-if="module !== 'results'"
                        aria-hidden="true">
                  </span>
                  <span class="glyphicon glyphicon-minus" v-else
                        aria-hidden="true">
                  </span>
                  <span :class="`label label-results`">
                    {{ modules.results.label }}
                  </span>
                </router-link>
                <collapse v-model="drawer.results" class="submenu-drawer">
                  <router-link tag="div" active-class="active"
                               role="button"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/results/results`">
                    <span class="glyphicon glyphicon-home"
                          aria-hidden="true">
                    </span>
                    Accueil
                  </router-link>
                  <router-link tag="div" active-class="active"
                               v-if="isRegistrator"
                               role="button"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/results/referents`">
                    <span class="glyphicon glyphicon-user"
                          aria-hidden="true">
                    </span>
                    Destinataires
                  </router-link>
                </collapse>
              </div>
            </div>
            <div v-for="t in availableSurveillanceTypes"
                 :class="`submenu-${t}`"
                 :key="`nav-${t}`">
              <hr>
              <div :class="{ 'submenu-active': t === module }">
                <router-link tag="div"
                             role="button"
                             class="no-outline action-button"
                             :to="`${moduleRoutePrefix}/${t}/dashboard`">
                  <span class="glyphicon glyphicon-plus"
                        v-if="t !== module"
                        aria-hidden="true">
                  </span>
                  <span class="glyphicon glyphicon-minus" v-else
                        aria-hidden="true">
                  </span>
                  <span :class="`label label-${t}`">
                    {{ modules[t].label }}
                  </span>
                </router-link>
                <collapse v-model="drawer[t]" class="submenu-drawer">
                  <router-link tag="div" active-class="active"
                               role="button"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/${t}/dashboard`">
                    <span class="glyphicon glyphicon-home"
                          aria-hidden="true">
                    </span>
                    Accueil
                  </router-link>
                  <router-link tag="div" active-class="active"
                               role="button"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/${t}/referents`">
                    <span class="glyphicon glyphicon-user"
                          aria-hidden="true">
                    </span>
                    Membres
                  </router-link>
                  <router-link tag="div" active-class="active"
                               role="button"
                               v-if="canEditSheets"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/${t}/sheets`">
                    <span class="glyphicon glyphicon-pencil"
                          aria-hidden="true">
                    </span>
                    Module de saisie
                  </router-link>
                  <router-link tag="div" active-class="active"
                               role="button"
                               v-if="canGetStatistics"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/${t}/data`">
                    <span class="glyphicon glyphicon-stats"
                          aria-hidden="true">
                    </span>
                    Données
                  </router-link>
                  <router-link tag="div" active-class="active"
                               v-if="hasCaracteristics"
                               role="button"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/${t}/caracteristics`">
                    <span class="glyphicon glyphicon-stats"
                          aria-hidden="true">
                    </span>
                    Caractéristiques
                  </router-link>
                </collapse>
              </div>
            </div>

            <div v-for="t in availableObservationTypes"
                 :class="`submenu-${t}`"
                 :key="`nav-${t}`">
              <hr>
              <div :class="{ 'submenu-active': t === module }">
                <router-link tag="div"
                             role="button"
                             class="no-outline action-button"
                             :to="`${moduleRoutePrefix}/${t}/dashboard`">
                  <span class="glyphicon glyphicon-plus"
                        v-if="t !== module"
                        aria-hidden="true">
                  </span>
                  <span class="glyphicon glyphicon-minus" v-else
                        aria-hidden="true">
                  </span>
                  <span :class="`label label-${t}`">
                    {{ modules[t].label }}
                  </span>
                </router-link>
                <collapse v-model="drawer[t]" class="submenu-drawer">
                  <router-link tag="div" active-class="active"
                               role="button"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/${t}/dashboard`">
                    <span class="glyphicon glyphicon-home"
                          aria-hidden="true">
                    </span>
                    Accueil
                  </router-link>
                  <router-link tag="div" active-class="active"
                               role="button"
                               v-if="t === 'observa4' || t === 'spy4'"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/${t}/referents`">
                    <span class="glyphicon glyphicon-user"
                          aria-hidden="true">
                    </span>
                    Membres
                  </router-link>
                  <router-link tag="div" active-class="active"
                               role="button"
                               v-if="canEditSheets"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/${t}/sheets`">
                    <span class="glyphicon glyphicon-pencil"
                          aria-hidden="true">
                    </span>
                    Module de saisie
                  </router-link>
                  <router-link tag="div" active-class="active"
                               role="button"
                               v-if="t === 'observa4' && parseInt(year) >= 2021"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/${t}/o4results`">
                    <span class="glyphicon glyphicon-stats" aria-hidden="true">
                    </span>
                    Résultats
                  </router-link>
                </collapse>
              </div>
            </div>
            <div v-for="t in availableResearchTypes"
                 :class="`submenu-${t}`"
                 :key="`nav-${t}`">
              <hr>
              <div :class="{ 'submenu-active': t === module }">
                <router-link tag="div"
                             role="button"
                             class="no-outline action-button"
                             :to="`${moduleRoutePrefix}/${t}/dashboard`">
                  <span class="glyphicon glyphicon-plus"
                        v-if="t !== module"
                        aria-hidden="true">
                  </span>
                  <span class="glyphicon glyphicon-minus" v-else
                        aria-hidden="true">
                  </span>
                  <span :class="`label label-${t}`">
                    {{ modules[t].label }}
                  </span>
                </router-link>
                <collapse v-model="drawer[t]" class="submenu-drawer">
                  <router-link tag="div" active-class="active"
                               role="button"
                               class="no-outline action-button"
                               :to="`${moduleRoutePrefix}/${t}/dashboard`">
                    <span class="glyphicon glyphicon-home"
                          aria-hidden="true">
                    </span>
                    Accueil
                  </router-link>

                </collapse>
              </div>
            </div>
          <div v-for="t in availableCauseAnalysisTypes"
               :class="`submenu-${t}`"
               :key="`nav-${t}`">
            <hr>
            <div :class="{ 'submenu-active': t === module }">
              <router-link tag="div"
                           role="button"
                           class="no-outline action-button"
                           :to="`${moduleRoutePrefix}/${t}/dashboard`">
                <span class="glyphicon glyphicon-plus"
                      v-if="t !== module"
                      aria-hidden="true">
                </span>
                <span class="glyphicon glyphicon-minus" v-else
                      aria-hidden="true">
                </span>
                <span :class="`label label-${t}`">
                  {{ modules[t].label }}
                </span>
              </router-link>
              <collapse v-model="drawer[t]" class="submenu-drawer">
                <router-link tag="div" active-class="active"
                             role="button"
                             class="no-outline action-button"
                             :to="`${moduleRoutePrefix}/${t}/dashboard`">
                  <span class="glyphicon glyphicon-home"
                        aria-hidden="true">
                  </span>
                  Accueil
                </router-link>
                <router-link tag="div" active-class="active"
                             role="button"
                             v-if="canEditSheets"
                             class="no-outline action-button"
                             :to="`${moduleRoutePrefix}/${t}/sheets`">
                  <span class="glyphicon glyphicon-pencil"
                        aria-hidden="true">
                  </span>
                  Module de saisie
                </router-link>
              </collapse>
            </div>
          </div>
      </div>

          <div v-else class="text-center">
            <p>
              <sui-loading-text>Chargement</sui-loading-text>
            </p>
            <br />
          </div>
        </collapse>
        <collapse v-else v-model="show">
          <p class="nav-title text-center">
            Veuillez sélectionner un établissement.
          </p>
          <br />
        </collapse>
      </div>
    </div>
  </div>
</template>
<script>
import checkboxMenu from '@/components/checkboxMenu'
import cheatsheet from '@/components/sheet/add/cheatsheet'
import suiLoadingText from '@/sui/components/loadingtext'
import modules from '@/sui/data/modules'
import denominators from '@/sui/data/sheets/edit/denominators'
import toolsUsage from '@/sui/data/sheets/edit/toolsUsage'
import caracteristics from '@/sui/data/caracteristics'

import { mapGetters } from 'vuex'

export default {
  name: 'establishments-navigation',

  props: {
    options: {
      type: Array,
      required: true
    }
  },

  data: function () {
    return {
      show: true
    }
  },

  computed: {
    ...mapGetters({
      all: 'surveillances/all',
      get: 'surveillances/get',
      loaded: 'surveillances/loaded',
      error: 'surveillances/error',
      userId: 'user/id'
    }),

    otherSurveillances: function () {
      if (this.surveillance == null) {
        return []
      }

      return this.all[this.surveillance.year]
    },

    modules: function () {
      return modules[this.year]
    },

    denominatorsAvailable: function () {
      return denominators[this.year] != null
    },

    toolsUsageSheetAvailable: function () {
      return toolsUsage[this.year] != null
    },

    mainClass: function () {
      return {
        'navigation-opened': this.show,
        'navigation-closed': !this.show
      }
    },

    sid: function () {
      return this.$route.params.id
    },

    module: function () {
      return this.$route.params.st
    },

    drawer: function () {
      const result = {}
      this.surveillance.availableSheetModules.forEach(
        t => { result[t] = t === this.module }
      )
      result.results = this.module === 'results'

      return result
    },

    year: function () {
      return this.$route.params.year
    },

    surveillance: function () {
      return this.get(this.year, this.sid)
    },

    moduleRoutePrefix: function () {
      return `${this.routePrefix}/module`
    },

    routePrefix: function () {
      return `/establishments/${this.$route.params.year}/${this.sid}`
    },

    isRegistrator: function () {
      return this.surveillance.isRegistrator(this.userId)
    },

    hasGlobalStatistics: function () {
      if (this.surveillance.isRegistrator(this.userId)) {
        return true
      }
      for (let m in this.surveillance.modules) {
        if (this.surveillance.canGetStatistics(this.userId, m)) {
          return true
        }
      }
      return false
    },

    validModule: function () {
      return this.surveillance != null && this.module != null &&
             this.module !== 'denominators'
    },

    hasCaracteristics: function () {
      if (!this.validModule ||
          caracteristics.flatten[this.module] == null ||
          !this.surveillance.canGetStatistics(this.userId, this.module)) {
        return false
      }

      const m = this.surveillance.modules[this.module]
      if (m == null) {
        return false
      }

      for (let i in m.dset) {
        const d = m.dset[i]
        if (d.step >= 1) {
          return true
        }
      }
      return false
    },

    canEditSheets: function () {
      return this.validModule &&
             this.module !== 'reaSink' &&
             this.module !== 'reaExplaur' &&
             this.surveillance.canEditSheets(this.userId, this.module)
    },

    canGetStatistics: function () {
      if (this.surveillance.year !== 2019) {
        return false
      }
      return this.validModule &&
             this.surveillance.canGetStatistics(this.userId, this.module)
    },

    availableSurveillanceTypes: function () {
      const result = []
      if (this.surveillance == null) {
        return result
      }

      return this.surveillance.availableSurveillanceModules
    },

    availableObservationTypes: function () {
      const result = []
      if (this.surveillance == null) {
        return result
      }
      return this.surveillance.availableObservationModules
    },

    availableResearchTypes: function () {
      const result = []
      if (this.surveillance == null) {
        return result
      }
      return this.surveillance.availableResearchModules
    },

    availableCauseAnalysisTypes: function () {
      const result = []
      if (this.surveillance == null) {
        return result
      }
      return this.surveillance.availableCauseAnalysisModules
    },

    resultModule: function () {
      if (this.surveillance.year === 2019) {
        return null
      }

      return this.surveillance.modules.results
    }
  },

  components: {
    'sui-loading-text': suiLoadingText,
    'checkbox-menu': checkboxMenu,
    'cheatsheet': cheatsheet
  }
}
</script>
<style scoped lang="less">
@import '~modules';
@import '~variables';

#establishments-navigation {
  width: 23rem;

  @media (min-width: 0) and (max-width: @screen-sm-max) {
    display: inline-block;
    width: 100%;
  }

  .navigation-sticky {
    background-color: lighten(@dark-base, 20%);
  }

  .navigation-bar {
    width: 23rem;
    @media (min-width: 0) and (max-width: @screen-sm-max) {
      width: 100%;
    }
    background-color: @dark-base;

    p {
      color: white;
    }

    .navigation-toggle {
      margin: 0.8rem 15px;
    }

    .navigation-contents {
      width: 23rem;

      @media (min-width: 0) and (max-width: @screen-sm-max) {
        width: 100%;
      }
      padding: 1rem 0rem;

      .nav-title {
        padding: 0rem 1rem;
      }

      hr {
        border-color: lighten(@base, 20%);
        width: 90%;
        margin: 0.5rem auto;
      }

      .dropdown-menu hr {
        border-color: fade(black, 20%);
      }

      .action-button {
        width: 100%;
        font-size: 88%;
        padding: 0.4rem 1rem;
        color: lighten(@base, 40%);
        font-weight: bold;

        .label {
          font-size: 100%;
        }

        span.glyphicon {
          font-size: 120%;
          margin-right: 0.3rem;
          vertical-align: text-top;
        }
      }

      .action-button:hover {
        width: 100%;
        background-color: lighten(@base, 35%);
        color: @dark-base;
      }

      .action-button.active {
        background-color: white;
        color: @dark-base;
      }

      .submenu-drawer .action-button{
        padding-left: 3rem;
      }

      each(.modules(), .(@value, @key) {
        .submenu-@{key} {
          .action-button:hover {
            background-color: lighten(@value, 35%);
            color: darken(@value, 15%);
          }

          .action-button.active {
            color: darken(@value, 15%);
          }

          .submenu-active {
            background-color: @value;
          }
        }
      });
    }
  }

  .top-sticky .navigation-bar {
    width: 100%;
  }

}
</style>
